import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  IoChevronBackOutline,
  IoChevronForwardOutline,
  IoFilterCircleOutline,
} from "react-icons/io5";

import CardHeading from "../../../shared/CardHeading";
import DropdownField from "../../../shared/DropdownField";
import { visitStatusOptions } from "../../../utils/dropdownOptions";
import {
  getVisitsList,
  setVisitFiltersPayload,
} from "../../../redux/slices/VisitsSlice";
import CheckPermission from "../../../hooks/CheckPermission";
import TextInput from "../../../shared/TextInput";
import AutoCompleteField from "../../../shared/AutoCompleteField";
import {
  nurseOptionsFormat,
  visitSearchPatientOptionsFormat,
} from "../../../constants/VisitsConstants";
import { fetchData } from "../../../helpers/fetchData";
import { useTranslation } from "react-i18next";
import { Calendar } from "primereact/calendar";
import CustomButton from "../../../shared/CustomButton";
import toast from "react-hot-toast";

export const filterPayload = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== "" && value !== null && value !== undefined && value !== 0
    )
  );
};

const VisitsFilters = ({ filtersPayload, setFiltersPayload, order }) => {
  const currentDate = moment().format("DD-MM-YYYY");
  const formatedTodayDate = moment(currentDate, "DD-MM-YYYY").toDate();
  const auth = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const [selctedPatient, setSelectedPatient] = useState(null);
  const { hasPermission } = CheckPermission();
  const { practitionersList, visitCategoryFilter, visitStatusFilter } =
    useSelector((state) => state?.visits);
  const [practitionerOptions, setPractionerOptions] = useState([]);
  const isRcmAssistant = useSelector(
    (state) => state.auth.user?.role?.name_en == "Rcm Assistant"
  );
  const { t } = useTranslation();
  useEffect(() => {
    if (practitionersList) {
      let formatedPractionerOptions = practitionersList?.data?.map(
        (practioner) => {
          return {
            label: practioner?.name,
            value: practioner?.practitioner_id,
          };
        }
      );
      setPractionerOptions(formatedPractionerOptions);
    }
  }, [practitionersList]);

  const handleChange = (event) => {
    const { name, value } = event.target || {};

    setFiltersPayload((prevValues) => ({
      ...prevValues,
      [name || event?.target?.name]: value,
    }));
  };

  const handleApplyFilters = () => {
    const formatedStartDate = filtersPayload?.start_date
      ? moment(filtersPayload?.start_date).format("YYYY-MM-DD")
      : "";
    const formatedEndDate = filtersPayload?.end_date
      ? moment(filtersPayload?.end_date).format("YYYY-MM-DD")
      : "";

    let payload = {
      status: filtersPayload?.status || "All",
      patient_id: filtersPayload?.patient_id || "",
      practitioner_id: filtersPayload?.practitioner_id || "",
      visit_no: Number(filtersPayload?.visit_no) ?? null,
      order_no: filtersPayload?.order_no ?? "",
      nurse_id: filtersPayload?.nurse_id ?? "",
      payment_status: filtersPayload?.payment_status ?? "",
      start_date: formatedStartDate,
      end_date: formatedStartDate,
      invoice_no: Number(filtersPayload?.invoice_no) ?? null,
      company_invoice_no: Number(filtersPayload?.company_invoice_no) ?? null,
      visit_category:
        filtersPayload?.visit_category ?? visitCategoryFilter,
      priority: filtersPayload?.priority || "",
      page: 1,
      perPage: 10,
    };
    dispatch(getVisitsList(payload));
    const newPayload = {
      ...filtersPayload,
      start_date: formatedStartDate,
      end_date: formatedStartDate,
    };
    setFiltersPayload(newPayload);
    dispatch(setVisitFiltersPayload(newPayload));
  };

  const handleResetFilters = () => {
    let payload = {
      patient_id: "",
      practitioner_id: isRcmAssistant ? "" : filtersPayload?.practitioner_id,
      visit_no: null,
      order_no: "",
      nurse_id: filtersPayload?.nurse_id,
      status: "All",
      start_date: "",
      end_date: "",
      invoice_no: null,
      company_invoice_no: null,
      visit_category:
        filtersPayload?.visit_category ?? visitCategoryFilter,
      priority: filtersPayload?.priority || "",
      payment_status: visitStatusFilter,
      page: 1,
      perPage: 10,
    };
    setSelectedPatient(null);
    dispatch(getVisitsList(payload)).then(() => {
      const newPayload = {
        ...payload,
        start_date: formatedTodayDate,
        end_date: formatedTodayDate,
      };

      setFiltersPayload(newPayload);
      dispatch(setVisitFiltersPayload(newPayload));
    });
  };
  return (
    <div className="w-full">
      <VisitFilterSidebar
        auth={auth}
        handleApplyFilters={handleApplyFilters}
        handleResetFilters={handleResetFilters}
        handleChange={handleChange}
        isRcmAssistant={isRcmAssistant}
        filtersPayload={filtersPayload}
        visitStatusOptions={visitStatusOptions}
        practitionerOptions={practitionerOptions}
        setFiltersPayload={setFiltersPayload}
        setSelectedPatient={setSelectedPatient}
        selctedPatient={selctedPatient}
        isHasNursePermission={hasPermission("nurse", "get")}
        order={order}
        isHasPractitionerPermission={hasPermission("practitioner", "get")}
      />
    </div>
  );
};

const VisitFilterSidebar = ({
  auth,
  handleApplyFilters,
  handleResetFilters,
  handleChange,
  filtersPayload,
  setFiltersPayload,
  visitStatusOptions,
  selctedPatient,
  setSelectedPatient,
  isHasNursePermission,
  order,
  isRcmAssistant,
}) => {
  const { t, i18n } = useTranslation();
  const [nursesList, setNursesList] = useState([]);
  const [fieldsLoading, setFieldsLoading] = useState(false);
  const [practionerList, setPractionerList] = useState([]);
  const prevVisitFilters = useSelector((state) => state?.visits?.visitFilters);
  const dispatch = useDispatch();
  const isNurse = useSelector(
    (state) => state.auth.user?.role?.name_en == "Nurse"
  );
  const isPractitioner = useSelector(
    (state) => state.auth.user?.role?.name_en == "Practitioner"
  );

  const getPractiionerList = async () => {
    const res = await fetchData("POST", "v3/practitioner/getByDepartment", {});
    if (res?.data) {
      setPractionerList(res?.data);
    }
  };

  useEffect(() => {
    if (isRcmAssistant) {
      getPractiionerList();
    }
  }, []);

  const getNurseData = async () => {
    setFieldsLoading(true);
    let response = await fetchData("POST", "v3/nurse/get");
    response?.data ? setNursesList(response?.data) : setNursesList([]);
    setFieldsLoading(false);
  };

  useEffect(() => {
    if (isHasNursePermission && !isNurse) {
      getNurseData();
    }
  }, [isHasNursePermission]);

  const handlePatientSelect = (data) => {
    const label = `${data?.full_name} --- ${data?.document_id} --- ${data?.file_no}`;
    const value = data?.patient_id;
    const patientData = data;
    setSelectedPatient(value);
    setFiltersPayload((prevValues) => ({
      ...prevValues,
      patient_id: value,
    }));
  };

  const handleDateChange = (event) => {
    const { name, value } = event.target || {};
    const formatedStartDate = moment(value).format("YYYY-MM-DD");
    setFiltersPayload((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    let payload = {
      ...filtersPayload,
      start_date: formatedStartDate,
      end_date: formatedStartDate,
    };

    dispatch(getVisitsList(payload));
    dispatch(setVisitFiltersPayload(payload));
  };

  const formatPractitionerOptions = (data) => {
    return data?.map((dt) => ({
      label: dt?.department_name,
      options: dt?.practitioners?.map((p) => ({
        label: p?.name,
        value: p?.practitioner_id,
      })),
    }));
  };

  return (
    <div>
      {/* {filtersPayload?.patient_id && (
        <CardHeading
          title={t("ApplyFilters")}
          Icon={IoFilterCircleOutline}
          iconSize="22"
        />
      )} */}
      <div className="flex felx-wrap justify-center items-center gap-4">
        <Calendar
          key={filtersPayload?.start_date || "calendar"}
          id="standalone-date-picker"
          name="start_date"
          placeholder={t("SelectStartDate")}
          onChange={handleDateChange}
          value={
            filtersPayload?.start_date
              ? moment(filtersPayload?.start_date, "YYYY/MM/DD").toDate()
              : ""
          }
          pt={{
            panel: { className: "!w-auto" },
          }}
          dateFormat="dd/mm/yy"
          hideOnDateTimeSelect={true}
          readOnlyInput
          showIcon={false}
          className="cursor-pointer bg-gray-100 !h-[30px]"
          nextIcon={
            i18n.language === "ar" ? (
              <IoChevronBackOutline />
            ) : (
              <IoChevronForwardOutline />
            )
          }
          prevIcon={
            i18n.language === "ar" ? (
              <IoChevronForwardOutline />
            ) : (
              <IoChevronBackOutline />
            )
          }
        />

        {!order && (
          <>
            <DropdownField
              className="!mb-0 !w-[200px]"
              name="status"
              placeholder={t("SelectStatus")}
              options={visitStatusOptions}
              value={filtersPayload?.status}
              onChange={handleChange}
              useFormik={false}
            />
            {isRcmAssistant && (
              <DropdownField
                className="!mb-0 !w-[200px]"
                name="practitioner_id"
                placeholder={t("SelectPractitioner")}
                options={formatPractitionerOptions(practionerList)}
                value={filtersPayload?.practitioner_id}
                onChange={handleChange}
                useFormik={false}
              />
            )}
            {auth?.user?.role?.name_en != "Practitioner" && (
              <TextInput
                parentClass="!mb-0 !w-[200px]"
                useFormik={false}
                placeholder={t("SearchPatientByDocumentId")}
                onChange={(e) => {
                  setSelectedPatient(e.target.value);
                }}
                value={selctedPatient || filtersPayload?.patient_id}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    try {
                      const res = await fetchData("POST", "v3/patient/filter", {
                        document_id: selctedPatient,
                      });
                      if (res?.data?.length === 1) {
                        handlePatientSelect(res?.data?.[0]);
                      } else {
                        toast.error(t("PatientNotFound"));
                      }
                    } catch (err) {
                      console.log(err);
                    }
                  }
                }}
              />
            )}
            {/* <TextInput
              placeholder={t('VisitNo')}
              name='visit_no'
              value={filtersPayload?.visit_no}
              onChange={handleChange}
              parentClass='!mb-0 '
              useFormik={false}
              type='number'
            />
            <TextInput
              placeholder={t('OrderNo')}
              name='order_no'
              value={filtersPayload?.order_no}
              parentClass='!mb-0 '
              onChange={handleChange}
              useFormik={false}
            />
            {!isNurse && (
              <DropdownField
                loading={fieldsLoading}
                filter
                showClear
                placeholder={t('Selectnurse')}
                name='nurse_id'
                parentClass='!mb-0 '
                options={nurseOptionsFormat(nursesList)}
                value={filtersPayload?.nurse_id}
                onChange={handleChange}
                useFormik={false}
              />
            )}

            <TextInput
              placeholder={t('InvoiceNo')}
              parentClass='!mb-0 '
              name='invoice_no'
              value={filtersPayload?.invoice_no}
              onChange={handleChange}
              useFormik={false}
              type='number'
            />
            <TextInput
              placeholder={t('CompanyInvoiceNo')}
              parentClass='!mb-0'
              name='company_invoice_no'
              value={filtersPayload?.company_invoice_no}
              onChange={handleChange}
              useFormik={false}
              type='number'
            /> */}
            <div className="flex flex-col gap-2 items-center lg:flex-row">
              <CustomButton
                //label={t("Filter")}
                title={t("Filter")}
                buttonType="primary"
                icon={"pi pi-filter"}
                className="h-[35px] w-full"
                onClick={handleApplyFilters}
              />
              <CustomButton
                //label={t("Reset")}
                title={t("Reset")}
                buttonType="reset"
                icon={"pi pi-sync"}
                className="h-[35px] w-full"
                onClick={handleResetFilters}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VisitsFilters;
